import { render, staticRenderFns } from "./AiLlmManage.vue?vue&type=template&id=28051312&scoped=true&"
import script from "./AiLlmManage.vue?vue&type=script&lang=js&"
export * from "./AiLlmManage.vue?vue&type=script&lang=js&"
import style0 from "./AiLlmManage.vue?vue&type=style&index=0&id=28051312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28051312",
  null
  
)

export default component.exports